// extracted by mini-css-extract-plugin
export default {"input":"Tag_input__KZ9aM","tag-box":"Tag_tag-box__GvU6v","tag-bg-dark":"Tag_tag-bg-dark__H+EUn","tag-bg-light":"Tag_tag-bg-light__oul30"};